import { render, staticRenderFns } from "./EditMember.component.vue?vue&type=template&id=86b60e2c&"
import script from "./EditMember.component.vue?vue&type=script&lang=ts&"
export * from "./EditMember.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports